import { render, staticRenderFns } from "./importCreate.vue?vue&type=template&id=051beec4&scoped=true&"
import script from "./importCreate.vue?vue&type=script&lang=js&"
export * from "./importCreate.vue?vue&type=script&lang=js&"
import style0 from "./importCreate.vue?vue&type=style&index=0&id=051beec4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051beec4",
  null
  
)

export default component.exports